<template>
  <div class="media-kit mk-container">
    <Breadcrumbs />
    <div style="max-width:1024px; text-align: center;">
      <!-- <h2>Not yet!</h2> -->
      <CommonEmptyContent />
    </div>
    <Paganiniplus />
  </div>
</template>

<script>
import Paganiniplus from '@/components/tsp/Paganiniplus'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import CommonEmptyContent from '@/components/common/DummyStatus/CommonEmptyContent'

export default {
  name: 'MediaKit',
  components: {
    Paganiniplus,
    Breadcrumbs,
    CommonEmptyContent
  },
  props: {},
  data() {
    return {}
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    title() {
      // const productionName = this.$production.toUpperCase()
      const productionLocaleName = this.$t(`${this.$production.toUpperCase()}.TITLE`)
      return `${this.$t('MEDIA_KIT.TITLE')} | ${productionLocaleName} | MUZIK AIR`
    },
    description() {
      return this.$t('MEDIA_KIT.TITLE')
    },
    cover() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const coverPath = this.$production.toLowerCase()
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
    },
    keywords() {
      return this.$t('MEDIA_KIT.TITLE')
    },
    canonicalURL() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/mediaKit`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/mediaKit`
    },
    structuredData() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const urlSubDomain = isAirProduction ? '' : `${process.env[subDomainKey]}.`
      const structuredData = {
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        '@id': this.canonicalURL,
        url: this.canonicalURL,
        image: this.cover,
        name: this.title,
        description: this.title,
        relatedLink: [
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/terms`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/about`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/mediaKit`
        ]
      }
      return structuredData
    }
  },
  created() {},
  async mounted() {
  },
  methods: {}
}
</script>
<style lang="scss">
</style>
